export default __webpack_public_path__ + "static/ombralsun-3-beb4957b54eb51d7b407fea178c6a094.jpg";